import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
import pdf from 'pdfobject';
import { printNum } from '@/api/modules/printPreview';
export default {
  name: 'PdfPreview',
  data: function data() {
    return {
      taskId: this.$route.query.taskId,
      baseUrl: this.$route.query.baseUrl,
      options: {
        pdfOpenParams: {// navpanes: 1,
          // view: 'FitH',
          // pagemode: 'thumbs'
        }
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      pdf.embed(_this.baseUrl, '#pdfPreview');
    });
    this.getPrintNum();
  },
  methods: {
    getPrintNum: function getPrintNum() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return printNum({
                  taskId: _this2.taskId
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};